import React from "react";
import { ConnectWalletInstruction } from "../component/ConnectWallet/ConnectWalletInstruction";
import { Loading } from "../component/Loading/Loading";
import { BN, contracts, divisor, numberFormat } from "../constants";
import { Web3Context } from "../store/Web3Store";
import {
  Button,
  Card,
  Col,
  message as AntDesignMessage,
  Row,
  Space,
  Typography,
} from "antd";

const { Title, Text } = Typography;

// Ropsten
const WAGMI_V1_ADDRESS = "0x8aD45681c53e7c6BdbB1E6113CE104d192F6F654";
const WAGMI_V2_ADDRESS = "0xad941e29887f6b0B4f58d6B5fbC3A3AeCA9d684F";

export const BridgePage = () => {
  const { web3, account } = React.useContext(Web3Context);
  const [loading, setLoading] = React.useState(true);
  const [bridgeData, setBridgeData] = React.useState(null);

  const handleApproval = async () => {
    const wagmiV1Contract = new web3.eth.Contract(
      contracts.wagmiAbiJson,
      WAGMI_V1_ADDRESS
    );
    return wagmiV1Contract.methods
      .approve(
        WAGMI_V2_ADDRESS,
        "115792089237316195423570985008687907853269984665640564020457584007913129639935"
      )
      .send({
        from: account,
      })
      .then(() => {
        AntDesignMessage.success("$WAGMI Contract Approved!", 10);
        mainFunc();
      })
      .catch((error) => {
        AntDesignMessage.error(error.message, 10);
      });
  };

  const bridge = async () => {
    const wagmiV2Contract = new web3.eth.Contract(
      contracts.wagmiV2AbiJson,
      WAGMI_V2_ADDRESS
    );
    wagmiV2Contract.methods
      .migrateFromV1toV2()
      .send({ from: account })
      .then(() => {
        AntDesignMessage.success("Successfully bridge to V2", 10);
        mainFunc();
      })
      .catch((error) => {
        AntDesignMessage.error(error.message, 10);
      });
  };

  const mainFunc = async () => {
    const wagmiV1Contract = new web3.eth.Contract(
      contracts.wagmiAbiJson,
      WAGMI_V1_ADDRESS
    );
    const wagmiV2Contract = new web3.eth.Contract(
      contracts.wagmiAbiJson,
      WAGMI_V2_ADDRESS
    );

    const balanceOfV1 = new BN(
      await wagmiV1Contract.methods.balanceOf(account).call()
    ).div(divisor);
    const balanceOfV2 = new BN(
      await wagmiV2Contract.methods.balanceOf(account).call()
    ).div(divisor);
    const approvalLimit = new BN(
      await wagmiV1Contract.methods.allowance(account, WAGMI_V2_ADDRESS).call()
    ).div(divisor);
    setBridgeData({
      balanceOfV1: balanceOfV1.toNumber(),
      balanceOfV2: balanceOfV2.toNumber(),
      hasApproved: balanceOfV1.lt(approvalLimit),
    });
    setLoading(false);
  };

  React.useEffect(() => {
    if (!!web3 && !!account) {
      mainFunc();
    }
  }, [account]);

  if (!web3) {
    return <ConnectWalletInstruction />;
  } else if (loading) {
    return <Loading />;
  }
  return (
    <Row justify="center">
      <Col>
        <Row>
          <Title level={2}>Bridge from WAGMI V1 to WAGMI V2</Title>
        </Row>
        <Row>
          <Text>Note: This is a one-way bridge from V1 to V2</Text>
        </Row>
        <br />
        <br />
        <Card>
          <Row justify="center">
            <Space direction="vertical" size="middle">
              <Row>
                <Text strong>WAGMI V1 Balance: &nbsp;</Text>
                {numberFormat.format(bridgeData.balanceOfV1)} WAGMI
              </Row>
              <Row>
                <Text strong>WAGMI V2 Balance: &nbsp;</Text>
                {numberFormat.format(bridgeData.balanceOfV2)} WAGMI V2
              </Row>
              <Row justify="center">
                {!bridgeData.hasApproved ? (
                  <Button type="primary" onClick={handleApproval}>
                    Approve
                  </Button>
                ) : (
                  <Button type="primary" onClick={bridge}>
                    Bridge {bridgeData.balanceOfV1} $WAGMI
                  </Button>
                )}
              </Row>
            </Space>
          </Row>
        </Card>
      </Col>
    </Row>
  );
};
